import $http from './http'
import config from './config'

export default {
    name: 'wechat',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    getAdapterList(data) {
        return $http.post(this.getUrl(`/proxy/GetAdapterList`), data);
    },
    getMenuList(id) {
        return $http.get(this.getUrl(`/proxy/GetMenuList?appid=${id}`))
    },
    getUpdateMenu(id,data) {
        return $http.post(this.getUrl(`/proxy/UpdateMenu?appid=${id}`), data);
    },
    getDeleteMenu(id) {
        return $http.get(this.getUrl(`/proxy/DeleteMenu?appid=${id}`))
    },
    synccompany(){
        return $http.get(this.getUrl('/workwechat/SyncCompany'));
    }
}



// WEBPACK FOOTER //
// ./src/apis/wechatApi.js